import AdminEvidenceTemplateDescriptionsAclName from './names/AdminEvidenceTemplateDescriptionsAclName';
import AmqpQueues from './names/AmqpQueues';
import BookkeepingAclName from './names/BookkeepingAclName.js';
import ChecklistAclName from './names/ChecklistAclName.js';
import CrmPartnerAclName from './names/crm-partner-acl-name';
import CrmAclName from './names/CrmAclName.js';
import DashboardAclName from './names/DashboardAclName';
import DemoAclName from './names/DemoAclName.js';
import EmployeeAclName from './names/EmployeeAclName';
import FilesAclName from './names/FilesAclName.js';
import ksefAclNames from './names/ksef-acl-names';
import MailingAclName from './names/MailingAclName';
import ProfileAclName from './names/ProfileAclName';
import SettingsAclName from './names/SettingsAclName.js';
import SettlementsAclNames from './names/SettlementsAclNames.js';
import StaffAclName from './names/StaffAclName.js';
import WebsitesAclName from './names/WebsitesAclName';

export default {
  ...AdminEvidenceTemplateDescriptionsAclName,
  ...AmqpQueues,
  ...BookkeepingAclName,
  ...ChecklistAclName,
  ...CrmAclName,
  ...CrmPartnerAclName,
  ...DashboardAclName,
  ...DemoAclName,
  ...EmployeeAclName,
  ...FilesAclName,
  ...MailingAclName,
  ...ProfileAclName,
  ...SettingsAclName,
  ...SettlementsAclNames,
  ...StaffAclName,
  ...WebsitesAclName,
  ...ksefAclNames,
};
